import { rgba } from 'polished';
import styled from 'styled-components';
import Typography from '@atoms/Typography';
import Avatar from '@atoms/Avatar';
import { devices } from 'config/devices';

export const TopSection = styled.div`
  background-image: ${({ background }) => `url(${background})`};
  background-size: cover;
  background-position: center;
  height: 21.875rem;
  margin-bottom: -10rem;
  
  @media ${devices.sm} {
    margin-top: -1rem;
  }
  @media ${devices.xs} {
    /* flex-basis: 100%; */
    margin-bottom: -6rem;

  }
  display: flex;
  justify-content: center;
  /* padding-right: 6rem; */
`;

export const Title = styled(Typography)`
  && {
    color: ${({ theme }) => theme.white};
    margin-bottom: 3.125rem;
    line-height: 1em;
  }
`;

export const OrganisationContainer = styled.div`
  background-color: ${({ theme }) => rgba(theme.common.black, 0.75)};
  height: 21.875rem;
  width: 19rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: ${({ theme }) => theme.white};
  
  

`;

export const OrgAvatar = styled(Avatar)`
  border: 2px solid ${({ theme }) => theme.primary.main};
  margin-bottom: 1rem;
`;
